import React from 'react';
import TableElementInterface from 'components/organisms/players-to-exchange/table-elements/table-element-interface';

const TableRowComponent = (props: {player: Array<TableElementInterface>; isPlayerBeyondSalaryCap}) => {
    return (
        <tr className={props.isPlayerBeyondSalaryCap ? 'exceeding-row' : ''}>
            {props.player.map((playerProperty, index) => {
                return <td key={index}>{playerProperty.value}</td>;
            })}
        </tr>
    );
};

export {TableRowComponent};
